import React, { useState } from 'react';
import { Box, TextField, TextareaAutosize, Button } from "@mui/material";

function ContactForm() {
    const [name, setName] = useState('');
    const [email, setEmail] = useState('');
    const [message, setMessage] = useState('');

    const handleNameChange = (event) => {
        setName(event.target.value);
    };

    const handleEmailChange = (event) => {
        setEmail(event.target.value);
    };

    const handleMessageChange = (event) => {
        setMessage(event.target.value);
    };

    const handleSubmit = (event) => {
        // event.preventDefault();
        // Add your logic here to handle form submission
        // console.log('Name:', name);
        // console.log('Email:', email);
        // console.log('Message:', message);
    };

    return (
        <Box display={'flex'}  alignItems={'center'} width={'100%'} className='contactContainer'>
            <Box component={'form'} display={'flex'} flexDirection={'column'} alignItems={'center'} marginTop={'50px'} marginLeft={'25%'} width={'50%'} onSubmit={handleSubmit} action="https://formspree.io/f/mdoqadan" method="POST">
            <p style={{ fontSize: '1rem', width: '80%', marginBottom: '5px', marginTop: '20px', textAlign: 'center' }}>I'm always interested in hearing about new projects,
                 so if you'd like to chat, contact me directly or fill
                  out the form and I will be back to you soon.</p>
                <TextField
                    label="Name"
                    value={name}
                    onChange={handleNameChange}
                    fullWidth
                    margin="normal"
                    required={true}
                    color="success"
                    style={{ backgroundColor: 'white' }}
                    name={'name'}
                />
                <TextField
                    label="Email"
                    value={email}
                    onChange={handleEmailChange}
                    fullWidth
                    margin="normal"
                    required={true}
                    type={'email'}
                    color="success"
                    style={{ backgroundColor: 'white' }}
                    name={'email'}
                />
                <TextareaAutosize
                    placeholder="Message *"
                    value={message}
                    onChange={handleMessageChange}
                    margin="normal"
                    required={true}
                    style={{ width: '100%', height: '150px', padding: '10px' }}
                    color="success"
                    name={'message'}
                />
                <Button type="submit" variant="contained" color="success" style={{ marginTop: '10px' }}>
                    Send Message
                </Button>
            </Box>
        </Box>
    );
}

export default ContactForm;